module.exports = __webpack_public_path__ + "img/材料力学1_5_6.02ccb644.jpg";